import { Navigate } from "react-router-dom";

type Props = {
    children: React.ReactNode;
};

const RequirePlaygroundAccess = ({ children }: Props) => {
    const userRole = localStorage.getItem("user_role");

    const isSystemUser = userRole === "system_user";

    /**
     * Allow if:
     * - system_user (stage/prod)
     */

    if (!isSystemUser) {
        return <Navigate to="/demo-lab" replace />;
    }

    return <>{children}</>;
};

export default RequirePlaygroundAccess;